import React, { useState } from 'react';

import Header from '../Component/Header';
import Footer from '../Component/Footer';

const CommunityCityInfo = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  
  
  return (
    <>
      <Header />


<main className="flex-1">
  <div className="min-h-screen bg-gray-50">
    <div className="sticky top-0 z-40 bg-white border-b border-gray-200 px-4 py-3 lg:hidden">
      <div className="flex items-center justify-between">
        <a className="flex items-center text-gray-600" href="/community/delhi">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-arrow-left h-5 w-5 mr-2"
          >
            <path d="m12 19-7-7 7-7" />
            <path d="M19 12H5" />
          </svg>
          <span className="text-sm">Back to Community</span>
        </a>
        <h1 className="text-lg font-semibold text-gray-900">Join Delhi</h1>
        <div className="w-16" />
      </div>
    </div>
    <div className="relative h-64 lg:h-80 overflow-hidden">
      <img
        alt="Delhi Travel Community"
        loading="lazy"
        decoding="async"
        data-nimg="fill"
        className="object-cover"
        style={{
          position: "absolute",
          height: "100%",
          width: "100%",
          inset: 0
        }}
        src="https://www.dev.connectingtraveller.com//images/city/1661965639.jpg"
      />
      <div className="absolute inset-0 bg-black/40" />
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center text-white px-4">
          <h1 className="text-2xl lg:text-4xl font-bold mb-2">
            Join Delhi Travel Community
          </h1>
          <p className="text-lg lg:text-xl opacity-90 max-w-2xl">
            Join Delhi's most active travel community and explore India's
            capital with like-minded travelers.
          </p>
        </div>
      </div>
    </div>
    <div className="max-w-4xl mx-auto px-4 py-8 lg:py-12">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <div className="bg-white rounded-lg p-4 text-center shadow-sm">
          <div className="flex items-center justify-center mb-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-users h-5 w-5 text-primary mr-1"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx={9} cy={7} r={4} />
              <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
            <span className="text-2xl font-bold text-gray-900">980</span>
          </div>
          <p className="text-sm text-gray-600">Community Members</p>
        </div>
        <div className="bg-white rounded-lg p-4 text-center shadow-sm">
          <div className="flex items-center justify-center mb-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-calendar h-5 w-5 text-primary mr-1"
            >
              <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
              <line x1={16} x2={16} y1={2} y2={6} />
              <line x1={8} x2={8} y1={2} y2={6} />
              <line x1={3} x2={21} y1={10} y2={10} />
            </svg>
            <span className="text-2xl font-bold text-gray-900">3x</span>
          </div>
          <p className="text-sm text-gray-600">Monthly Meetups</p>
        </div>
        <div className="bg-white rounded-lg p-4 text-center shadow-sm">
          <div className="flex items-center justify-center mb-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-map-pin h-5 w-5 text-primary mr-1"
            >
              <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
              <circle cx={12} cy={10} r={3} />
            </svg>
            <span className="text-2xl font-bold text-gray-900">2020</span>
          </div>
          <p className="text-sm text-gray-600">Year Founded</p>
        </div>
        <div className="hidden md:block bg-white rounded-lg p-4 text-center shadow-sm">
          <div className="flex items-center justify-center mb-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-star h-5 w-5 text-primary mr-1"
            >
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
            </svg>
            <span className="text-2xl font-bold text-gray-900">650</span>
          </div>
          <p className="text-sm text-gray-600">Active Members</p>
        </div>
      </div>
      <div className="grid lg:grid-cols-2 gap-8">
        <div>
          <h2 className="text-2xl font-bold text-gray-900 mb-6">
            Why Join Delhi Travel Community?
          </h2>
          <div className="space-y-4 mb-8">
            <div className="flex items-start">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-check-circle2 h-5 w-5 text-primary mt-0.5 mr-3 flex-shrink-0"
              >
                <circle cx={12} cy={12} r={10} />
                <path d="m9 12 2 2 4-4" />
              </svg>
              <span className="text-gray-700">
                Heritage walks and food tours
              </span>
            </div>
            <div className="flex items-start">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-check-circle2 h-5 w-5 text-primary mt-0.5 mr-3 flex-shrink-0"
              >
                <circle cx={12} cy={12} r={10} />
                <path d="m9 12 2 2 4-4" />
              </svg>
              <span className="text-gray-700">
                Weekend trips to hill stations
              </span>
            </div>
            <div className="flex items-start">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-check-circle2 h-5 w-5 text-primary mt-0.5 mr-3 flex-shrink-0"
              >
                <circle cx={12} cy={12} r={10} />
                <path d="m9 12 2 2 4-4" />
              </svg>
              <span className="text-gray-700">
                Connect with 980+ Delhi travelers
              </span>
            </div>
            <div className="flex items-start">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-check-circle2 h-5 w-5 text-primary mt-0.5 mr-3 flex-shrink-0"
              >
                <circle cx={12} cy={12} r={10} />
                <path d="m9 12 2 2 4-4" />
              </svg>
              <span className="text-gray-700">
                Photography meetups at monuments
              </span>
            </div>
          </div>
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-gray-900">
              What Members Say
            </h3>
            <div className="bg-white rounded-lg p-4 shadow-sm border-l-4 border-primary">
              <p className="text-gray-700 mb-2 italic">
                "Amazing community with passionate travelers. Love the heritage
                walks!"
              </p>
              <div className="flex items-center">
                <div>
                  <p className="font-medium text-gray-900">Vikram J.</p>
                  <p className="text-sm text-gray-600">Local Expert</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="bg-white rounded-xl shadow-lg border-2 border-primary/20 overflow-hidden sticky top-24">
            <div className="bg-gradient-to-r from-primary to-primary/80 text-white p-4 text-center">
              <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-white text-primary mb-2">
                Limited Time Offer
              </div>
              <h3 className="text-xl font-bold">Join Delhi Community</h3>
              <p className="text-primary-foreground/90">
                One-time membership fee
              </p>
            </div>
            <div className="p-6">
              <div className="text-center mb-6">
                <div className="flex items-center justify-center gap-3 mb-2">
                  <span className="text-2xl text-gray-500 line-through">
                    ₹499
                  </span>
                  <span className="text-4xl font-bold text-primary">₹99</span>
                </div>
                <p className="text-sm text-gray-600">80% off regular price</p>
              </div>
              <div className="space-y-3 mb-6">
                <div className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check-circle2 h-4 w-4 text-primary mr-3 flex-shrink-0"
                  >
                    <circle cx={12} cy={12} r={10} />
                    <path d="m9 12 2 2 4-4" />
                  </svg>
                  <span className="text-sm text-gray-700">
                    Access to all city meetups
                  </span>
                </div>
                <div className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check-circle2 h-4 w-4 text-primary mr-3 flex-shrink-0"
                  >
                    <circle cx={12} cy={12} r={10} />
                    <path d="m9 12 2 2 4-4" />
                  </svg>
                  <span className="text-sm text-gray-700">
                    Exclusive travel deals &amp; discounts
                  </span>
                </div>
                <div className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check-circle2 h-4 w-4 text-primary mr-3 flex-shrink-0"
                  >
                    <circle cx={12} cy={12} r={10} />
                    <path d="m9 12 2 2 4-4" />
                  </svg>
                  <span className="text-sm text-gray-700">
                    Connect with verified travelers
                  </span>
                </div>
                <div className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check-circle2 h-4 w-4 text-primary mr-3 flex-shrink-0"
                  >
                    <circle cx={12} cy={12} r={10} />
                    <path d="m9 12 2 2 4-4" />
                  </svg>
                  <span className="text-sm text-gray-700">
                    Priority booking for trips
                  </span>
                </div>
                <div className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check-circle2 h-4 w-4 text-primary mr-3 flex-shrink-0"
                  >
                    <circle cx={12} cy={12} r={10} />
                    <path d="m9 12 2 2 4-4" />
                  </svg>
                  <span className="text-sm text-gray-700">
                    24/7 community support
                  </span>
                </div>
                <div className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check-circle2 h-4 w-4 text-primary mr-3 flex-shrink-0"
                  >
                    <circle cx={12} cy={12} r={10} />
                    <path d="m9 12 2 2 4-4" />
                  </svg>
                  <span className="text-sm text-gray-700">
                    Lifetime membership access
                  </span>
                </div>
              </div>
              <button onClick={handleOpenModal} className="inline-flex items-center justify-center whitespace-nowrap rounded-md ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 w-full bg-primary hover:bg-primary/90 text-white py-6 text-lg font-semibold">
                Join Delhi Community Now
              </button>
              <div className="flex items-center justify-center mt-4 text-sm text-gray-500">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-shield h-4 w-4 mr-2"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
                </svg>
                <span>Secure payment • No recurring charges</span>
              </div>
              <div className="flex items-center justify-center mt-2 text-sm text-gray-500">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-award h-4 w-4 mr-2"
                >
                  <circle cx={12} cy={8} r={6} />
                  <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11" />
                </svg>
                <span>30-day satisfaction guarantee</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-12 bg-white rounded-xl p-6 shadow-sm">
        <h3 className="text-xl font-bold text-gray-900 mb-4">
          Frequently Asked Questions
        </h3>
        <div className="space-y-4">
          <div>
            <h4 className="font-medium text-gray-900 mb-1">
              Is this a one-time payment?
            </h4>
            <p className="text-gray-600 text-sm">
              Yes, pay once and get lifetime access to the Delhi travel
              community with no recurring fees.
            </p>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-1">
              How quickly will I get access?
            </h4>
            <p className="text-gray-600 text-sm">
              You'll receive access instructions via email within 5 minutes of
              completing your payment.
            </p>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-1">
              Are meetups free for members?
            </h4>
            <p className="text-gray-600 text-sm">
              Most local meetups are free. Special trips may have additional
              costs, but members get preferential rates.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

</main>






      <Footer />
	  


	  
	  
	  
    </>
  );
};

export default CommunityCityInfo;
